import AuthenticationState from "interfaces/state/AuthenticationState";
import moment from "moment";
import { getAuthInfoFromStorage } from "shared/utility/TokenStorageUtility";
import { RootState, store } from "store/store";
import { ApplicationUserRole } from "shared/enums/ApplicationUserRoleEnum";

const getAuthState = (): AuthenticationState => {
  const authState = store.getState().authData;
  return authState;
};

export const getPortalToken = () => {
  const state = getAuthState();
  return state.token || getAuthInfoFromStorage()?.token;
};

const getTokenExpieryTime = () => {
  const state = getAuthState();
  return state.expires || getAuthInfoFromStorage()?.expires;
};

export const checkIfUserHasValidPortalToken = () => {
  const portalToken = getPortalToken();
  const expires = getTokenExpieryTime();

  if (portalToken && expires && moment(expires) > moment()) {
    return true;
  }

  return false;
};

export const checkIfUserIsLoggedIn = () => {
  return checkIfUserHasValidPortalToken();
};

export const checkIfCurrentUserHasAdminAccess = (state: RootState) => {
  return state.authData.role & ApplicationUserRole.ApplicationAdministrator;
};
